// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1fYOy","bigColWidth":"Table_bigColWidth__V1KOG","biggerColWidth":"Table_biggerColWidth__2oHxC","row":"Table_row__Kw26J","col":"Table_col__3JrMP"};